var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_319",
    "data-name": "Subtraction 319",
    d: "M12143.458-9378.029h-12.62a2.691,2.691,0,0,1-2.688-2.687v-3.155a.584.584,0,0,1,.583-.583.584.584,0,0,1,.584.583v3.155a1.521,1.521,0,0,0,1.521,1.519h12.62a1.52,1.52,0,0,0,1.52-1.519v-3.155a.587.587,0,0,1,.59-.583.584.584,0,0,1,.582.583v3.155A2.693,2.693,0,0,1,12143.458-9378.029Zm-6.31-5.259a.571.571,0,0,1-.411-.172l-.063-.06-3.1-3.1a.576.576,0,0,1-.172-.414.59.59,0,0,1,.172-.415.579.579,0,0,1,.415-.171.574.574,0,0,1,.411.171l1.812,1.812.35.35v-10.162a.584.584,0,0,1,.583-.583.585.585,0,0,1,.585.583v10.162l2.159-2.161a.574.574,0,0,1,.411-.171.583.583,0,0,1,.415.171.6.6,0,0,1,.171.415.574.574,0,0,1-.171.414l-3.155,3.156A.587.587,0,0,1,12137.148-9383.288Z",
    transform: "translate(-12128.149 9396.029)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/downloadFile.c0615eb6580a430d8dd9f843b448de93.svg";
export { ForwardRef as ReactComponent };